<template>
  <div class="container">
    <img class="bgImage" :src="ourMissionInfo.backImg" alt="">
    <div class="title">{{ ourMissionInfo.title }}</div>
    <div class="subTitle line1">{{ ourMissionInfo.subtitle[0] }}</div>
    <div class="subTitle line2">{{ ourMissionInfo.subtitle[1] }}</div>
  </div>
</template>
<script>
export default {
  name: "OurMission",
  props: {
    ourMissionInfo: {
      type: Object, defaults() {
        return {}
      }
    }
  },
  data() {
    return {
    }
  }
}
</script>
<style lang="scss" scoped>
.container {
  position: relative;
  padding-left: 229px;
  height: 596px;

  .bgImage {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 596px;
    z-index: -1;
  }

  .title {
    text-align: left;
    padding-top: 108px;
    font-size: 64px;
    font-family: "SourceHanSansSC-Bold-2";
    font-weight: bold;
    color: #FFFFFF;
  }

  .subTitle {
    text-align: left;
    font-size: 48px;
    font-family: "SourceHanSansSC-Bold-2";
    font-weight: bold;
    color: #FFFFFF;
  }

  .line1 {
    margin-top: 88px;
  }

  .line2 {
    margin-top: 40px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/homepage/childComps/OurMission.vue